import { Role } from '../types/user.type';

export const checkRole = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return (
    role.name === 'agent' ||
    role.name === 'mentor' ||
    role.name === 'admin' ||
    role.name === 'ticketing-admin' ||
    role.name === 'ticketing-member'
  );
};

export const isLoggedAgent = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return role.name === 'agent';
};

export const isLoggedSupervisor = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return role.name === 'supervisor';
};

export const isLoggedAdmin = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return role.name === 'admin';
};

export const isLoggedTicketingAdmin = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return role.name === 'ticketing-admin';
};

export const isLoggedTicketingMember = (role?: Role | null) => {
  if (!role) {
    return false;
  }

  return role.name === 'ticketing-member';
};

export const displayRole = (role: Role | string) => {
  if (!role) {
    return 'No Role';
  }

  if (typeof role === 'string') {
    switch (role) {
      case 'ticketing-admin':
        return 'Ticketing Admin';
      case 'ticketing-member':
        return 'Ticketing Member';
      default:
        return role.charAt(0).toUpperCase() + role.slice(1);
    }
  }

  switch (role?.name) {
    case 'ticketing-admin':
      return 'Ticketing Admin';
    case 'ticketing-member':
      return 'Ticketing Member';
    default:
      return role?.name?.charAt(0).toUpperCase() + role?.name?.slice(1);
  }
};
